import script from "./TextSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TextSection.vue?vue&type=script&setup=true&lang=js"

import "./TextSection.vue?vue&type=style&index=0&id=223c36ff&lang=scss"
import "./TextSection.vue?vue&type=style&index=1&id=223c36ff&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223c36ff"]])

export default __exports__